import { render, staticRenderFns } from "./BsCheckboxGroup.vue?vue&type=template&id=a07594aa&"
import script from "./BsCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./BsCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./BsCheckboxGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports